import React, { Component } from "react";
import getUrlParams from "../../../../../utils/getUrlParams";

class FamilyTitleTestbase extends Component {
  state = {
    ref: React.createRef()
  };

  componentDidMount() {
    const urlFamily = `FID${getUrlParams().FID}`;
    const componentFamily = this.state.ref.current;
    const offsetAdjustment = urlFamily === "FID1" ? 110 : 50;
    if (urlFamily === componentFamily.id) {
      const offset = componentFamily.offsetTop - offsetAdjustment;
      window.scrollTo(0, offset);
    }
  }

  render() {
    const { familyID, family } = this.props;
    return (
      <h2
        ref={this.state.ref}
        className="family__title"
        id={`FID${familyID.toString()}`}
      >
        {family}
      </h2>
    );
  }
}

export default FamilyTitleTestbase;
